import * as yup from 'yup';

const schema = yup.object().shape({
  cardNumber: yup.string().required('Required field'),
  holderName: yup.string().required('Required field'),
  validity: yup.string().required('Required field'),
  cvv: yup.string().required('Required field')
});

export default schema;